import {DEFAULT_LEVEL, UserReportDetailDialogController} from './UserReportDetailDialogController';
import moment from 'moment';

export const ADDROUTE = 'administration.addUserReport';
export const ADDTITLE = 'ADD_USERREPORT';

export const DELETEROUTE = 'administration.deleteUserReport';
export const DELETETITLE = 'DELETE_USERREPORT';
/** @ngInject */
export class AddUserReportController extends UserReportDetailDialogController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, "create");
        const startDate = moment();
        startDate.subtract(10,'days');
        this.element = { active: true, unRead: false, lastStatement: false,
          dateRange: {lowerBound: startDate, upperBound: moment()}, days:0, futureDays: 10, showAccounts: true,
            access: DEFAULT_LEVEL, editing: DEFAULT_LEVEL};
        $scope.detailForm = {};
        this.loaded = true;
    }
}
